import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

interface Props {
  fallback: any;
  loader: () => Promise<any>;
  render: (component: any) => any;
}

const intersectionOptions = {
  root: null,
  rootMargin: "32px",
  threshold: 0.2,
};

export default function LazyInView({ fallback, loader, render }: Props) {
  const [ref, inView] = useInView(intersectionOptions);
  const [lazyModule, setLazyModule] = useState(null);

  useEffect(() => {
    async function loadLazyModule() {
      try {
        const component = await loader();

        setLazyModule(component);
      } catch (err) {
        setLazyModule(null);
      }
    }

    if (inView && !lazyModule) {
      loadLazyModule();
    }
  }, [inView, lazyModule, loader]);

  return <div ref={ref}>{lazyModule ? render(lazyModule) : fallback}</div>;
}
